import React from 'react';

/**
 * Simple theme provider that doesn't use Emotion 
 * This is a simplified version used to avoid Emotion errors
 */
const SimpleThemeProvider = ({ theme, children }) => {
  // Make theme available via legacy context API
  // This should be enough for most basic theme functionality
  const legacyContext = {
    theme,
    __SIMPLE_THEME_PROVIDER__: true
  };
  
  // Apply global styles directly using style tag
  const globalStyles = `
    body {
      margin: 0;
      padding: 0;
      font-family: sans-serif;
    }
  `;
  
  return (
    <div className="theme-provider">
      <style>{globalStyles}</style>
      {children}
    </div>
  );
};

export default SimpleThemeProvider;